import { Message, Text } from '@oy/uidesktop';
import { IS_DANARAPAY } from 'src/constants';
import styles from './MessageMaintenance.module.css';
import { useMessageMaintenance } from './useMessageMaintenance';

type MessageMaintenanceProps = {
  type?: string;
};

const generateMessage = (queueable: boolean, allowFailover: boolean) => {
  if (queueable && !allowFailover) {
    return 'notifications_message_description3_queue';
  } else if (!queueable && !allowFailover) {
    return 'notifications_message_description3_autoFailed';
  }
  return 'notifications_message_description3_allowH2HFailover';
};

export const MessageMaintenance = ({
  type = 'info',
}: MessageMaintenanceProps) => {
  const { data, emailLink, getTranslation } = useMessageMaintenance();
  const { queueable, allow_failover } = data || {};
  return (
    <Message
      type={type === 'warning' ? Message.Type.Warning : Message.Type.Info}
      showIcon
    >
      <Text textStyle={Text.Style.BodyMdRegular}>
        {getTranslation('notifications_message_description1')}
      </Text>
      <div className={styles.content}>
        <Text textStyle={Text.Style.BodyMdRegular}>
          <ol>
            <li>{getTranslation('notifications_message_description2')}</li>
            <li>
              {getTranslation(
                generateMessage(queueable || false, allow_failover || false),
              )}
            </li>
          </ol>
        </Text>
      </div>
      <Text textStyle={Text.Style.BodyMdRegular}>
        {getTranslation('notifications_message_description4')}
        <a href={emailLink} target="_blank" rel="noreferrer">
          {` ${
            IS_DANARAPAY
              ? 'ops@danarapay.com'
              : getTranslation('common_email_partner_helpdesk')
          }.`}
        </a>
      </Text>
    </Message>
  );
};
